module.exports = __webpack_public_path__ + "img/talk_4.bf80cc16.png";